import {
  ACTION_GET_REQUESTING,
  ACTION_GET_SUCCESS,
  ACTION_GET_ERROR,
  ACTION_SET_BEST,
  ACTION_GET_ALL_LIST_REQUESTING,
  ACTION_GET_ALL_LIST_ERROR,
  ACTION_GET_ALL_LIST_SUCCESS,
  ACTION_GET_SELECTION_LIST_REQUESTING,
  ACTION_GET_SELECTION_LIST_ERROR,
  ACTION_GET_SELECTION_LIST_SUCCESS,
  ACTION_UPDATE_SELECTION_REQUESTING,
  ACTION_UPDATE_SELECTION_SUCCESS,
  ACTION_UPDATE_SELECTION_ERROR,
  ACTION_CHECK,
  ACTION_SELECT_TAB,
  ACTION_CLOSE_SNACK_MESSAGE,
  ACTION_CREATION_MODIFY,
  ACTION_CREATE_REQUESTING,
  ACTION_CREATE_ERROR,
  ACTION_CREATE_SUCCESS,
  ACTION_DELETE_PRIVATE_ERROR,
  ACTION_MODIFY_PRIVATE_ERROR,
  ACTION_MODIFY_PRIVATE_REQUESTING,
  ACTION_DELETE_PRIVATE_REQUESTING,
  ACTION_GET_PRIVATE_REQUESTING,
  ACTION_GET_PRIVATE_ERROR,
  ACTION_GET_PRIVATE_SUCCESS,
  ACTION_GET_SELECTED_REQUESTING,
  ACTION_GET_SELECTED_ERROR,
  ACTION_GET_SELECTED_SUCCESS,
  ACTION_DELETE_PRIVATE_SUCCESS,
  ACTION_MODIFY_PRIVATE_SUCCESS
} from "./constants";

import { AUTH_LOGOUT_SUCCESS } from "../auth/reducer";

const initialState = {
  bestActions: {
    leadership: {
      title: "",
      action: "",
      rating: 0
    },
    resilience: {
      rating: 0
    },
    proactivity: {
      rating: 0
    },
    publicSpeaking: {
      rating: 0
    },
    teamCohesion: {
      rating: 0
    }
  },
  selectionList: [],
  allActions: [],
  myActionsCreated: [],
  myActionsSelected: [],
  isSnackMessage: false,
  tabSelected: 0,
  title: "",
  how: "",
  why: "",
  category: "leadership",
  snackMessage: "",
  error: null,
  requesting: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_GET_SUCCESS: {
      const { category, title } = action.payload;
      const bestActions = Object.assign({}, { ...state.bestActions });
      bestActions[category].title = title;
      return { ...state, bestActions, requesting: false };
    }

    case ACTION_GET_SELECTED_ERROR:
    case ACTION_GET_PRIVATE_ERROR:
    case ACTION_DELETE_PRIVATE_ERROR:
    case ACTION_MODIFY_PRIVATE_ERROR:
    case ACTION_CREATE_ERROR:
    case ACTION_GET_ALL_LIST_ERROR:
    case ACTION_UPDATE_SELECTION_ERROR:
    case ACTION_GET_SELECTION_LIST_ERROR:
    case ACTION_GET_ERROR: {
      return { ...state, error: action.payload, requesting: false };
    }

    case ACTION_GET_SELECTED_REQUESTING:
    case ACTION_GET_PRIVATE_REQUESTING:
    case ACTION_DELETE_PRIVATE_REQUESTING:
    case ACTION_MODIFY_PRIVATE_REQUESTING:
    case ACTION_CREATE_REQUESTING:
    case ACTION_GET_ALL_LIST_REQUESTING:
    case ACTION_UPDATE_SELECTION_REQUESTING:
    case ACTION_GET_SELECTION_LIST_REQUESTING:
    case ACTION_GET_REQUESTING: {
      return {
        ...state,
        requesting: true
      };
    }

    case ACTION_SET_BEST: {
      return {
        ...state,
        bestActions: action.payload
      };
    }

    case ACTION_GET_ALL_LIST_SUCCESS: {
      return {
        ...state,
        requesting: false,
        allActions: action.payload
      };
    }

    case ACTION_UPDATE_SELECTION_SUCCESS:
      return {
        ...state,
        isSnackMessage: true,
        snackMessage: "Changements validés",
        requesting: false
      };

    case ACTION_GET_SELECTION_LIST_SUCCESS: {
      return {
        ...state,
        requesting: false,
        selectionList: action.payload
      };
    }

    case ACTION_CHECK: {
      const actionIndex = state.selectionList.findIndex(
        el => el === action.payload
      );
      let selectionList = [];
      if (actionIndex > -1) {
        selectionList = state.selectionList.filter(el => el !== action.payload);
      } else {
        selectionList = [...state.selectionList, action.payload];
      }
      return {
        ...state,
        selectionList
      };
    }

    case ACTION_SELECT_TAB:
      return {
        ...state,
        tabSelected: action.payload
      };

    case ACTION_CLOSE_SNACK_MESSAGE:
      return {
        ...state,
        isSnackMessage: false
      };

    case ACTION_CREATION_MODIFY:
      return {
        ...state,
        ...action.payload
      };

    case ACTION_CREATE_SUCCESS:
      return {
        ...state,
        requesting: false,
        isSnackMessage: true,
        title: "",
        how: "",
        why: "",
        category: "leadership",
        snackMessage: "Action créée avec succès !"
      };

    case ACTION_GET_PRIVATE_SUCCESS:
      return {
        ...state,
        requesting: false,
        myActionsCreated: action.payload
      };

    case ACTION_GET_SELECTED_SUCCESS:
      return {
        ...state,
        requesting: false,
        myActionsSelected: action.payload
      };

    case ACTION_DELETE_PRIVATE_SUCCESS: {
      let myActionsCreated = state.myActionsCreated.filter(
        el => el._id !== action.payload.actionId
      );
      let myActionsSelected = state.myActionsSelected.filter(
        el => el._id !== action.payload.actionId
      );
      let selectionList = state.selectionList.filter(
        el => el !== action.payload.actionId
      );
      return {
        ...state,
        requesting: false,
        myActionsSelected,
        myActionsCreated,
        selectionList
      };
    }

    case ACTION_MODIFY_PRIVATE_SUCCESS: {
      let myActionsCreated = state.myActionsCreated.map(el => {
        if (el._id === action.payload._id) {
          return action.payload;
        }
        return el;
      });
      return {
        ...state,
        requesting: false,
        isSnackMessage: true,
        snackMessage: "Action modifiée avec succès !",
        myActionsCreated
      };
    }

    case AUTH_LOGOUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
